<template>
	<div class="bj">
		<div>
			<div class="contents" style="margin-bottom: 6px;">
				<div class="tops">
					<div class="logo"><img src="../../assets/index/logo.png" /></div>
					<div class="lxwm"><img src="../../assets/lxwm.png" /></div>
				</div>
				<div class="nav">
					<div class="grid-content" @click="goTo('/login')">
						<div><img src="../../assets/left.svg" />返回首页</div>
					</div>
				</div>

			</div>
			<div class="routers" style="overflow-y: auto;height: calc(100vh - 216px);">
				<div class="kuan">
					<el-table :data="news" style="width: 100%" height="620">
						<el-table-column prop="title" label="标题">
							<template slot-scope="scope">
								<router-link style="color:#606266;" target="_blank" :to="'/show?id='+scope.row.id">
									{{ scope.row.title }}
								</router-link>
							</template>
						</el-table-column>
						<el-table-column prop="createtime_text" label="发布时间" width="130">
						</el-table-column>
					</el-table>
				</div>
				<Foot></Foot>
			</div>
		</div>

	</div>
	<!-- <div>
		<Menu></Menu>
		<div
			style="background-image:url(https://files.gsjtpxzx.com/public/assets/front/image/12.png);background-size: 100% 807px;">
			<div class="kuan">
				<div class="topss">
					<div class="title">
						{{shows.title}}
					</div>
					<div class="tag">
						<div>
							发布时间：{{shows.createtime_text}}
						</div>
						<div>
							发布者：Admin
						</div>
					</div>
				</div>
				<div class="content" v-html="shows.content">
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div> -->
</template>

<script>
	import Menu from '../../components/menu.vue'
	import Foot from '@/components/foot.vue'
	export default {
		components: {
			Menu,
			Foot
		},
		data() {
			return {
				news: []
			};
		},
		created() {
			this.getIndexNews()
		},
		methods: {
			goTo(path) {

				this.defaultStay = path
				window.sessionStorage.setItem('leftMenuDefaultKey', path)
				this.$router.replace(path);

			},
			//获取通知公告
			getIndexNews() {
				this.$http({
						method: 'POST',
						url: '/index/getIndexNews',
						headers: {
							requireAuth: false // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.news = response.data

						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
		}
	};
</script>

<style lang="scss" scoped>
	.bj {
		background-image: url(../../assets/bj.jpg);
		background-repeat: no-repeat;
		background-size: 100% auto;

	}

	.contents {
		width: 1400px;
		margin: 0 auto;
	}

	.tops {
		overflow: hidden;
		height: 140px;
	}

	.logo {
		width: 805px;
		height: 73px;
		padding-top: 43px;
		float: left;
	}

	.logo img {
		width: 805px;
		height: auto;
	}

	.lxwm {
		float: right;
		width: 330px;
		height: 68px;
		padding-top: 43px;
	}

	.lxwm img {
		width: 330px;
		height: 68px;
	}

	.nav {
		width: 100%;
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 5px;
		margin-top: 31px;
	}

	.grid-content {
		width: 168px;
		height: 46px;
		float: left;
		line-height: 50px;
		font-size: 18px;
		font-weight: bold;
		color: #1072DA;
		cursor: pointer;
	}

	.grid-content div {
		width: 114px;
		height: 45px;
		margin-left: 10px;

		img {
			width: 20px;
			height: 20px;
			padding-top: 14px;
			float: left;
		}
	}

	.kuan {
		width: 1380px;
		margin: 0 auto;
		padding: 0 10px;
		background: #FFFFFF;
		border: 1px solid #dcdfe6;

		.topss {
			width: 98%;
			min-height: 67px;
			border-bottom: 2px solid #1AA4E4;
			margin: 0 auto;

			.title {
				min-height: 30px;
				font-size: 32px;
				color: #000000;
				font-weight: 600;
				width: 85%;
				text-align: center;
				margin: 32px auto;
				background: none;
			}

			.tag {
				width: 100%;
				height: 20px;
				margin-bottom: 20px;

				div {
					&:nth-child(1) {
						float: right;
					}

					&:nth-child(2) {
						float: right;
						margin-right: 40px;
					}
				}
			}
		}
	}

	/* 滚动条整体 */
	.routers::-webkit-scrollbar {
		height: 20px;
		width: 2px;
	}

	/* 两个滚动条交接处 -- x轴和y轴 */
	.routers::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	/* 滚动条滑块 */
	.routers::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #535353;
	}

	/* 滚动条轨道 */
	.routers::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}

	.content {
		width: 98%;
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		line-height: 34px;
		letter-spacing: 0px;
		margin: 20px auto;
	}
</style>
